import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "photo-wrapper" }
const _hoisted_2 = { class: "image-slot" }
const _hoisted_3 = {
  key: 1,
  class: "photo-placeholder"
}
const _hoisted_4 = { class: "photo-label" }
const _hoisted_5 = { class: "photo-wrapper" }
const _hoisted_6 = { class: "image-slot" }
const _hoisted_7 = { class: "photo-label" }

import { computed } from 'vue'
import { PictureFilled } from '@element-plus/icons-vue'
import { EvTripExtended } from '@/models/evTrip'


export default /*@__PURE__*/_defineComponent({
  __name: 'TripImagesTab',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const getImageByType = (
  photos: { type: string; secure_url: string }[],
  type: string
) => {
  return photos?.find(photo => photo.type === type)
}

// Collect all pretrip photo URLs
const pretripPhotoUrls = computed(() => {
  const urls: string[] = []
  props.trip.pretrip_photo?.forEach(photo => {
    if (photo.secure_url) {
      urls.push(photo.secure_url)
    }
  })
  return urls
})

// Collect all aftertrip photo URLs
const aftertripPhotoUrls = computed(() => {
  const urls: string[] = []
  props.trip.aftertrip_photo?.forEach(photo => {
    if (photo.secure_url) {
      urls.push(photo.secure_url)
    }
  })
  return urls
})

// All photo URLs combined
const allPhotoUrls = computed(() => {
  return [...pretripPhotoUrls.value, ...aftertripPhotoUrls.value]
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { always: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        class: "image-section",
        gutter: 20
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "title" }, "Pretrip Photos", -1)),
              _createVNode(_component_el_row, { gutter: 10 }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              'frontImage',
              'backImage',
              'leftImage',
              'rightImage',
            ], (type) => {
                    return _createVNode(_component_el_col, {
                      key: type,
                      span: 4,
                      class: "photo-item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          (getImageByType(props.trip.pretrip_photo, type))
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: 
                    getImageByType(props.trip.pretrip_photo, type)
                      ?.secure_url || ''
                  ,
                                "preview-src-list": allPhotoUrls.value,
                                fit: "cover",
                                class: "photo-preview",
                                alt: ""
                              }, {
                                error: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_el_icon, { class: "image-slot-icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PictureFilled))
                                      ]),
                                      _: 1
                                    }),
                                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "image-slot-text" }, "Image not available", -1))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["src", "preview-src-list"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, "+"))
                        ]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(type), 1)
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _: 1,
            __: [1]
          })
        ]),
        _: 1
      }),
      (props.trip.aftertrip_photo?.length)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "image-section",
            gutter: 20
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "title" }, "Aftertrip Photos", -1)),
                  _createVNode(_component_el_row, { gutter: 10 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.trip.aftertrip_photo, (photo) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          key: photo.public_id,
                          span: 4,
                          class: "photo-item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_el_image, {
                                src: photo.secure_url,
                                "preview-src-list": allPhotoUrls.value,
                                fit: "cover",
                                class: "photo-preview",
                                alt: ""
                              }, {
                                error: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_el_icon, { class: "image-slot-icon" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PictureFilled))
                                      ]),
                                      _: 1
                                    }),
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "image-slot-text" }, "Image not available", -1))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["src", "preview-src-list"])
                            ]),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(photo.type), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})